/**
 * Page: RAG Articles
 * Affiche la liste des articles indexés pour le RAG
 */

import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import RagArticlesIndex from '../components/RagArticlesIndex';
import { useTranslation } from '../context/TranslationContext';
import debug from '@commons-shared/debug.js';
import { config } from '../config/environment.js';

export default function RagArticlesPage() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { loadPageTranslations } = useTranslation();
  const [world, setWorld] = useState(null);

  // Load page translations on mount
  useEffect(() => {
    loadPageTranslations('RAG_ARTICLES');
  }, [loadPageTranslations]);

  // Récupérer le monde sélectionné depuis le localStorage
  useEffect(() => {
    try {
      const waWorldString = localStorage.getItem('wa_world');
      if (waWorldString) {
        const waWorld = JSON.parse(waWorldString);
        setWorld(waWorld);
      } else {
        setWorld(null);
      }
    } catch (error) {
      debug.error(config, 'RagArticlesPage: Erreur lors de la lecture de wa_world:', error);
      setWorld(null);
    }
  }, []);

  if (!world) {
    return (
      <div className="p-6 text-center">
        <p className="text-gray-600">Aucun monde sélectionné. Veuillez d'abord sélectionner un monde WorldAnvil.</p>
        <button
          onClick={() => navigate('/config')}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Aller à la configuration
        </button>
      </div>
    );
  }

  return (
    <div className="w-full max-w-6xl mx-auto p-6">
      <RagArticlesIndex world={world} />
    </div>
  );
}
